import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.init();
    }

    init() {
      this.events = {
        click: {
            wishlist: 'wishlistOpen',
        },
        change: {
          variant: 'variantSelect',
        }
      };
      this.url = this.getData('url', this.el);
      this.label = this.getData('label', this.el);
      this.currentVariant = null;
      this.product = null;
    }

    variantSelect(e) {
      this.updateMasterId(e.currentTarget)
      this.updateUrl();
      this.updateVariantGallery();
    }

    updateMasterId(variant) {
      const title = this.getData('title', variant);
      const id = variant.getAttribute('value');
      this.product = JSON.parse(this.getData('data'));
      this.currentVariant = {}
      this.currentVariant.id = id;
      this.currentVariant.title = title;
      this.currentVariant.images = this.product.media.filter((image) => {
        if(image.alt) {
          return image.alt.includes(title)
        }
        
        return false
      });
    }

    updateUrl() {
      this.$("link").forEach((element, idx) => {
        element.href = `/products/${this.url}?variant=${this.currentVariant.id}`
      })
    }

    updateVariantGallery() {
      let imagesContent = "";

      this.currentVariant.images.forEach((image,i) => {
        imagesContent += `<div class="keen-slider__slide">
            <a
              class="c-lazy c-product-card_carousel-anchor"
              data-productcard="link"
              href="/products/${this.url}?variant=${this.currentVariant.id}">
            <img
              data-lazyload
              class="c-product-gallery_image"
              sizes="(min-width: 750px) calc(100vw - 22rem), 1100px"
              src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
              data-src="${image.src}"
              alt="${image.alt}">
            </a>
          </div>`

      })

      const carouselId = this.label ? `productcard${this.product.id}${this.label}` : `productcard${this.product.id}`;
      this.call('addNewImages', { images: imagesContent, thumbs: null}, 'Carousel', carouselId);
    }

    wishlistOpen(e) {
      this.call('menuOpen', null, 'Wishlist');
    }

    destroy() {
      
    }
}
